/**
 * La riga d'errore sotto un campo di un modulo, e il tono con cui si
 * scrive. Sta qui, e non accanto a uno dei due form, perché i moduli del
 * sito sono due (/contatti e il briefing di /accoglienza) e un errore
 * deve avere lo stesso aspetto in tutti e due: è la lingua con cui il
 * sito dice che qualcosa non va, non la decorazione di una pagina.
 */

/**
 * Il tono degli errori. È `--p-teatri-crisi`, cioè il rosso della scala
 * editoriale, e non un esadecimale scritto qui: i toni dei tipi sono
 * dichiarati due volte in `app/globals.css`, sotto `:root` e sotto
 * `.dark`, quindi questo segue il tema. Un `#9c2b27` fisso, nel tema
 * scuro, sarebbe un bordo che sparisce contro la carta.
 */
export const TONO_ERRORE = "var(--p-teatri-crisi)";

/** Il corpo è `text-nota` ma in tondo e senza tracking: dentro le
 *  `<label>` di un form, che possono essere uppercase spaziate, va
 *  rimesso a posto o la frase diventa illeggibile. */
export function MessaggioErrore({
  id,
  className = "",
  children,
}: {
  id?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <p
      id={id}
      className={`m-0 text-nota normal-case leading-[1.45] tracking-normal ${className}`}
      style={{ color: TONO_ERRORE }}
    >
      {children}
    </p>
  );
}
